module.exports = __webpack_public_path__ + "static/media/dolly-empty.88d61629.svg";